import React, { useEffect, useRef, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setActiveTab, setActiveTabList, fetchSymbolTokensRequest } from '../../store/reducers/marketReducer';
import { getAvailableTabs, getClientData } from '../custom';

const MarketTabs = () => {

  const availableTabs = useMemo(() => getAvailableTabs(), []);

  const dispatch = useDispatch();
  const { activeTab, activeTabList } = useSelector(state => state.market);

  const hasFetchedRef = useRef(false);

  useEffect(() => {
    if (!availableTabs.length) return;
    hasFetchedRef.current = true;
    // Reload the list on every mount (including back-navigation from add-order).
    // Use the already-selected tab if there is one, otherwise the default — this
    // way returning to Market re-fetches the WHOLE list instead of showing the
    // single cached script left over from the order screen.
    const tab = activeTab || availableTabs[0];
    if (!activeTab) dispatch(setActiveTab(tab));
    dispatch(fetchSymbolTokensRequest({ tab, list: activeTabList }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleTabChange = (tab) => {
    if (activeTab === tab) return;

    dispatch(setActiveTab(tab));
    dispatch(fetchSymbolTokensRequest({ tab, list: activeTabList }));
  };

  const handleTabListChange = (list) => {
    if (activeTabList === list) return;
    dispatch(setActiveTabList(list));
    dispatch(fetchSymbolTokensRequest({ tab: activeTab, list }));
  };
  return (
    <div className="mt-4">
      <div className="flex space-x-2">
        {availableTabs.map((tab) => (
          <button
            key={tab}
            className={`py-0 px-4 text-sm font-lato font-semibold ${activeTab === tab
              ? 'border-b-[2px] border-blue-500 text-blue-500'
              : 'hover:text-blue-500'
              }`}
            onClick={() => handleTabChange(tab)}
          >
            {tab}
          </button>
        ))}
      </div>

      <div className="flex items-center justify-center mt-2 mb-0">
        <div className="flex bg-gray-200 w-[200px] h-[35px]">
          <button
            type="button"
            onClick={() => handleTabListChange('Top Gainers')}
            className={`${activeTabList === 'Top Gainers'
              ? 'bg-[#2f67f0] text-white'
              : 'bg-gray-200 text-black'
              } w-1/2 h-full text-sm font-lato transition-colors`}
          >
            Top Gainers
          </button>
          <button
            type="button"
            onClick={() => handleTabListChange('Top Losers')}
            className={`${activeTabList === 'Top Losers'
              ? 'bg-[#2f67f0] text-white'
              : 'bg-gray-200 text-black'
              } w-1/2 h-full text-sm font-lato transition-colors`}
          >
            Top Losers
          </button>
        </div>
      </div>
    </div>
  );
};

export default MarketTabs;